var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.645,
    height: 26.06,
    viewBox: "0 0 25.645 26.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8247",
    "data-name": "Rectangle 8247",
    width: 25.645,
    height: 26.06,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15696",
    "data-name": "Group 15696",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M16.716.907a3.071,3.071,0,0,0-.833,1.511H.682a.679.679,0,1,0,0,1.357h15.2a3.129,3.129,0,0,0,.841,1.52l.017.016a3.091,3.091,0,0,0,4.269.055l.083-.079a3.061,3.061,0,0,0,.833-1.511h3.041a.679.679,0,1,0,0-1.357H21.927A3.126,3.126,0,0,0,21.086.9L21.069.883a3.094,3.094,0,0,0-4.353.023m2.189.452a1.722,1.722,0,0,1,1.206.483l.024.025a1.739,1.739,0,0,1-1.229,2.969h0A1.72,1.72,0,0,1,17.7,4.353l-.024-.025A1.738,1.738,0,0,1,18.9,1.358",
    transform: "translate(-0.002 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M4.559,74.095a3.066,3.066,0,0,0-.833,1.511H.686a.679.679,0,1,0,0,1.357H3.727A3.094,3.094,0,0,0,8.9,78.5l.033-.031a3.069,3.069,0,0,0,.833-1.511h15.2a.679.679,0,1,0,0-1.357H9.77a3.094,3.094,0,0,0-5.177-1.54Zm2.188.451a1.74,1.74,0,0,1,1.225,2.974l-.011.012a1.74,1.74,0,0,1-2.442-.017l-.044-.043a1.741,1.741,0,0,1,.048-2.422l.011-.012a1.733,1.733,0,0,1,1.214-.492",
    transform: "translate(-0.005 -53.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M4.559,25.21a3.067,3.067,0,0,0-.833,1.511H.686a.679.679,0,1,0,0,1.357H3.727A3.094,3.094,0,0,0,8.9,29.618l.033-.031a3.069,3.069,0,0,0,.833-1.511h15.2a.679.679,0,0,0,0-1.357H9.77a3.094,3.094,0,0,0-5.177-1.54Zm2.188.45a1.74,1.74,0,0,1,1.225,2.974l-.011.012a1.741,1.741,0,0,1-2.442-.017l-.043-.043a1.742,1.742,0,0,1,.047-2.423l.011-.012a1.734,1.734,0,0,1,1.214-.492",
    transform: "translate(-0.005 -17.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M15.88,51.214H.679a.679.679,0,1,0,0,1.357h15.2a3.116,3.116,0,0,0,.832,1.511,3.1,3.1,0,0,0,4.378,0L22.277,52.9l-.557.278a3.082,3.082,0,0,0,.2-.6h3.041a.679.679,0,1,0,0-1.357H21.921A3.116,3.116,0,0,0,21.09,49.7a3.095,3.095,0,0,0-4.379,0,3.113,3.113,0,0,0-.831,1.508m3.023-1.06a1.736,1.736,0,1,1-1.23.508,1.727,1.727,0,0,1,1.23-.508",
    transform: "translate(0 -35.552)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0bfc13471f36165738eb68e5e1ffbc8c.svg";
export { ForwardRef as ReactComponent };